// 是本科还是硕博映射
export const productLineMap = [
  ['MASTER', 'graduate'],
  ['UNDERGRADUATE', 'undergrad']
]
